import { render, staticRenderFns } from "./TankTempTable.vue?vue&type=template&id=10b61707"
import script from "./TankTempTable.vue?vue&type=script&lang=js"
export * from "./TankTempTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports